import { useParams } from 'react-router-dom';

import TabDisplay from '../TabDisplay';

import QueryResolver from '~/services/api/query-resolver';
import { ReportService } from '~/services/api/reports/endpoints';
import { AttachmentFolder } from '~/services/api/reports/types';

const CasemanagerAttachments = () => {
  const reportId = String(useParams().reportId);
  const query = ReportService.endpoints.casemanagerAttachment.useQuery({
    reportId: reportId,
  });

  const mutationToRefetch = () => {
    query.refetch();
  };

  return (
    <QueryResolver query={query}>
      {(item: AttachmentFolder) => (
        <TabDisplay item={item} mutationToRefetch={mutationToRefetch} />
      )}
    </QueryResolver>
  );
};

export default CasemanagerAttachments;
